import React, { useEffect, useState } from 'react';
import { Search, MapPin } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const SearchBar = ({ onSearch, initialKeyword = '', initialLocation = '' }) => {
  const [keyword, setKeyword] = useState(initialKeyword);
  const [location, setLocation] = useState(initialLocation);

  useEffect(() => setKeyword(initialKeyword), [initialKeyword]);
  useEffect(() => setLocation(initialLocation), [initialLocation]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch({ keyword, location });
  };

  return (
    <form onSubmit={handleSubmit} className="bg-card border border-border rounded-xl p-4 shadow-lg">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" size={20} />
          <Input
            type="text"
            placeholder="Job title or brand"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            className="pl-10 bg-background text-foreground"
          />
        </div>
        <div className="relative">
          <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" size={20} />
          <Input
            type="text"
            placeholder="Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className="pl-10 bg-background text-foreground"
          />
        </div>
        <Button type="submit" className="bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-200 active:scale-[0.98]">
          Search jobs
        </Button>
      </div>
    </form>
  );
};

export default SearchBar;
